export default function Logo({ size = 'medium', className = '' }) {
  const sizeClasses = {
    small: 'h-[50px]',
    medium: 'h-[80px]',
    large: 'h-[100px]'
  };

  const iconSizes = {
    small: { width: '70px', iconSize: '35px' },
    medium: { width: '100px', iconSize: '50px' },
    large: { width: '120px', iconSize: '60px' }
  };

  const textSizes = {
    small: {
      padding: '6px 20px 6px 25px',
      mainText: 'text-[16px]',
      subText: 'text-[9px] px-[6px] py-[1px]'
    },
    medium: {
      padding: '10px 30px 10px 35px',
      mainText: 'text-[24px]',
      subText: 'text-[12px] px-[8px] py-[2px]'
    },
    large: {
      padding: '15px 40px 15px 45px',
      mainText: 'text-[30px]',
      subText: 'text-[14px] px-[10px] py-[3px]'
    }
  };

  const sizeConfig = iconSizes[size];
  const textConfig = textSizes[size];

  return (
    <div 
      className={`inline-flex items-stretch ${sizeClasses[size]} rounded-lg overflow-hidden shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl ${className}`}
      style={{ cursor: 'pointer' }}
    >
      {/* Icon Section */}
      <div 
        className="relative flex items-center justify-center"
        style={{
          width: sizeConfig.width,
          background: 'linear-gradient(135deg, #ED1C24 0%, #C91820 100%)'
        }}
      >
        {/* Striped overlay effect */}
        <div 
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage: `repeating-linear-gradient(
              45deg,
              transparent,
              transparent 10px,
              rgba(255, 255, 255, 0.05) 10px,
              rgba(255, 255, 255, 0.05) 20px
            )`
          }}
        />
        
        {/* Skewed edge */}
        <div 
          className="absolute right-[-15px] h-full z-10"
          style={{
            width: '30px',
            background: 'linear-gradient(135deg, #ED1C24 0%, #C91820 100%)',
            transform: 'skewX(-10deg)'
          }}
        />
        
        {/* Navigation Icon */}
        <svg 
          className="relative z-20" 
          width={sizeConfig.iconSize} 
          height={sizeConfig.iconSize}
          viewBox="0 0 24 24" 
          xmlns="http://www.w3.org/2000/svg"
          fill="white"
        >
          <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z"/>
          <path d="M12 2v16"/>
          <circle cx="12" cy="8" r="2" fill="white"/>
        </svg>
      </div>

      {/* Text Section */}
      <div 
        className="relative flex flex-col justify-center bg-[#34495e]"
        style={{ padding: textConfig.padding }}
      >
        <div className={`text-white font-bold uppercase tracking-wide ${textConfig.mainText}`}>
          NAVIGATION.GR
        </div>
        <div 
          className={`text-white bg-[#ED1C24] inline-block rounded-sm uppercase tracking-wider font-semibold mt-1 ${textConfig.subText}`}
          style={{ width: 'fit-content' }}
        >
          TELENAVIS LOGISTICS OS
        </div>
      </div>
    </div>
  );
}
